/**
 * Created by SJ on 12/1/16.
 */
export const SET_TOAST_SHOW = 'SET_TOAST_SHOW'
export const SET_TOAST_HIDE = 'SET_TOAST_HIDE'
export const SHOW_TOAST = 'SHOW_TOAST'

export const SET_LOADING = 'SET_LOADING'

export const SET_DESTROY = 'SET_DESTROY'
export const SET_REGION = 'SET_REGION'
export const SET_LANG = 'SET_LANG'

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN = 'LOGIN'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const LOG_OUT = 'LOG_OUT'
export const CLEAR_URERINFO = 'CLEAR_URERINFO'
export const READ_TOKEN = 'READ_TOKEN'

export const SHOW_TAB = 'SHOW_TAB'
export const CLOSE_TAB = 'CLOSE_TAB'
export const SWITCH_TAB = 'SWITCH_TAB'
export const SELECT_WORKSTOP = 'SELECT_WORKSTOP'
export const SET_TAB_SHOW = 'SET_TAB_SHOW'
export const SET_TAB_CLOSE = 'SET_TAB_CLOSE'
export const SET_TAB_SELECT = 'SET_TAB_SELECT'
export const RESET_TAB_SELECT = 'RESET_TAB_SELECT'
export const CLEAR_TABS = 'CLEAR_TABS'
export const JUMP_ROUTE = 'JUMP_ROUTE'

export const HOME_NEWS_DETAIL = 'HOME_NEWS_DETAIL'
export const HOME_NEWS_DETAIL_SHOW = 'HOME_NEWS_DETAIL_SHOW'

export const SHOW_SHORTCUT = 'SHOW_SHORTCUT'
export const CLOSE_SHORTCUT = 'CLOSE_SHORTCUT'
export const SET_SHORTCUT_SHOW = 'SET_SHORTCUT_SHOW'
export const SET_SHORTCUT_CLOSE = 'SET_SHORTCUT_CLOSE'
export const GET_SHORTCUT = 'GET_SHORTCUT'

export const LOAD_PANELTOP = 'LOAD_PANELTOP'
export const LOAD_PANELTOP_REFRESH = 'LOAD_PANELTOP_REFRESH'
export const LOAD_PANELBOTTOM = 'LOAD_PANELBOTTOM'
export const LOAD_PANELBOTTOM_REFRESH = 'LOAD_PANELBOTTOM_REFRESH'
export const SET_REFRESH = 'SET_REFRESH'

/* export const HOME_NAV_LIST = 'HOME_NAV_LIST'
export const HOME_NAV_SHOW = 'HOME_NAV_SHOW' */
export const SWITCH_LIST = 'SWITCH_LIST'
export const LIST_SET = 'LIST_SET'

export const CHECK_TREE = 'CHECK_TREE'
export const DELETE_TREE = 'DELETE_TREE'
export const TREE_CHECK = 'TREE_CHECK'
export const TREE_DELETE = 'TREE_DELETE'



// WEBPACK FOOTER //
// ./src/store/types.js